import { IModeInitialState } from "../../../types/master/modeInterface";

import { ModeActionTypes, ModeActions } from "../../actionTypes/master/modeActionTypes";

const initialState: IModeInitialState = {
  modeList: [],
  modeData: {
    id: 0,
    mode_label: "",
    slug: "",
    created_by: 0,
  },
  modeListPageCount: 0,
};

export default function modeReducer(state = initialState, action: ModeActionTypes): IModeInitialState {
  switch (action.type) {
    case ModeActions.SET_MODE_LIST:
      return {
        ...state,
        modeList: action.payload,
      };

    case ModeActions.SET_MODE_LIST_PAGE_COUNT:
      return {
        ...state,
        modeListPageCount: action.payload
      };

    case ModeActions.SET_MODE_DATA_BY_ID:
      return {
        ...state,
        modeData: action.payload,
      };

    default:
      return state;
  }
}
